import { CloudflareInfoSection } from "./CloudflareInfoSection";
import { McpOverviewHeader } from "./McpOverviewHeader";
import { McpRawResponse } from "./McpRawResponse";
import { McpResponseAnalysis } from "./McpResponseAnalysis";
import { ToolCallInfo } from "./ToolCallInfo";
import type { McpDetailsSectionProps } from "./types";
import {
  extractMcpResponseData,
  extractMcpToolInfo,
  parseServerSentEvent,
} from "./utils";

export function McpDetailsSection({ span }: McpDetailsSectionProps) {
  const toolInfo = extractMcpToolInfo(span);
  const responseData = extractMcpResponseData(span);
  const parsedResponse = responseData.responseData
    ? parseServerSentEvent(responseData.responseData)
    : null;

  return (
    <div className="space-y-4 @container">
      <McpOverviewHeader {...responseData} />

      <div className="grid grid-cols-1 @[600px]:grid-cols-2 gap-4">
        <div>
          <ToolCallInfo toolInfo={toolInfo} />
        </div>
        <CloudflareInfoSection attributes={span.attributes} />

        <div className="@[600px]:col-span-2">
          {parsedResponse && (
            <McpResponseAnalysis parsedResponse={parsedResponse} />
          )}

          {responseData.responseData && !parsedResponse && (
            <McpRawResponse responseData={responseData.responseData} />
          )}
        </div>
      </div>
    </div>
  );
}
